import { Entity } from '@backstage/catalog-model';

export const RBAC_API_VERSION = 'rbac.backstage.io/v1alpha1';
export const RBAC_POLICY_KIND = 'RbacPolicy';
export const RBAC_ROLE_KIND = 'RbacRole';
export const RBAC_ROLE_BINDING_KIND = 'RbacRoleBinding';

export type RbacEffect = 'allow' | 'deny';

export type RbacStatement = {
  effect: RbacEffect;
  actions: string[];
  resources: string[];
  /** All refs must be present in the caller's effective ownership set. */
  requiredOwnershipRefs?: string[];
};

export type RbacPolicyEntity = Entity & {
  apiVersion: typeof RBAC_API_VERSION;
  kind: typeof RBAC_POLICY_KIND;
  spec: {
    statements: RbacStatement[];
  };
};

export type RbacRoleEntity = Entity & {
  apiVersion: typeof RBAC_API_VERSION;
  kind: typeof RBAC_ROLE_KIND;
  spec: {
    description?: string;
    policyRefs: string[];
  };
};

export type RbacRoleBindingSubject = {
  kind: 'User' | 'Group';
  ref: string;
};

export type RbacRoleBindingEntity = Entity & {
  apiVersion: typeof RBAC_API_VERSION;
  kind: typeof RBAC_ROLE_BINDING_KIND;
  spec: {
    roleRef: string;
    subjects: RbacRoleBindingSubject[];
  };
};

export type RbacEntity =
  | RbacPolicyEntity
  | RbacRoleEntity
  | RbacRoleBindingEntity;

export type RbacDecision = 'allow' | 'deny';

export type RbacEvaluateRequest = {
  subject: string;
  action: string;
  resource: string;
};

export type RbacMatchedStatement = RbacStatement & {
  policyRef: string;
  roleRef: string;
  bindingRef: string;
};

export type RbacEvaluateResponse = {
  decision: RbacDecision;
  matchedStatements: RbacMatchedStatement[];
};

export const TENANT_ADMIN_ACTIONS = [
  'catalog.entity.read',
  'catalog.entity.create',
  'catalog.entity.update',
  'catalog.entity.delete',
  'scaffolder.template.parameter.read',
  'scaffolder.template.step.read',
  'scaffolder.task.create',
  'scaffolder.task.read',
  'scaffolder.task.cancel',
  'scaffolder.action.execute',
  'scaffolder.template.management',
  'rbac.role.read',
  'rbac.role.manage',
];
